export const DiscountedPrice = (price,discount) =>Math.round((price*100)/(100-discount))

/*
Formula for markedprice
(sp*100)/(100-discount)
*/ 